import { h, Fragment, Component } from "preact";
import { observer } from "mobx-react";

import { Recommendation, ControllerProvider, } from "@searchspring/snap-preact-components";

import { Result } from '../../Result/Result'
import { MediaQuery } from '../../Helpers/MediaQuery'

import { ArrowLeft } from "../../Icons/ArrowLeft";
import { ArrowRight } from "../../Icons/ArrowRight";

// CSS
import './recs.css'

@observer
export class Recs extends Component {
  constructor(props) {
    super();

    const controller = props.controller;

    if (!controller.store.profile) {
      controller.init();
      controller.search();
    }
  }

  render() {
    const controller = this.props.controller;
    const store = controller?.store;

    // Seems to fix the Recommended Product Carousel display
    const loopSlideCount = store.results.length > 5 ? 1 : 0;

    const breakpointsMobile = {
      0: {
        slidesPerView: 1.05,
        slidesPerGroup: 1,
        spaceBetween: 20,
        centeredSlides: true,
        loopAdditionalSlides: 1,
      }
    };

    const breakpointsDesktop = {
      0: {
        slidesPerView: 3.5,
        slidesPerGroup: 1,
        spaceBetween: 20,
        centeredSlides: true,
        loopAdditionalSlides: loopSlideCount
      },
    };

    const breakpointsSmall = {
      0: {
        slidesPerView: 3.5,
        slidesPerGroup: 1,
        spaceBetween: 20,
        centeredSlides: true,
        loop: true,
      },
    };

    return (
      <ControllerProvider controller={this.props.controller}>
        <div class="ss__recommendation__inner-wrap">
          {store.results.length > 4 &&
            <MediaQuery query="(min-width: 750px)">
              <Recommendation 
                controller={controller}
                pagination={true}
                prevButton={<ArrowLeft/>}
                nextButton={<ArrowRight/>}
                breakpoints={breakpointsDesktop}
                allowTouchMove={false}
              >
                {store.results.map((result) => (
                  <Result result={result}></Result>
                ))}
              </Recommendation>
            </MediaQuery>
          }
          
          {/* 
            Recently Viewed Carousels -
            For new customers this will sometimes only render out a few products
            Change the parameters here so that the few products on centered on Desktop w/o looping or arrows enabled
          */}
          {store.results.length <= 4 &&
            <MediaQuery query="(min-width: 750px)">
              <Recommendation 
                controller={controller}
                pagination={false}
                breakpoints={breakpointsSmall}
                allowTouchMove={false}
                hideButtons={true}
              >
                {store.results.map((result) => (
                  <Result result={result}></Result>
                ))}
              </Recommendation>
            </MediaQuery>
          }

          <MediaQuery query="(max-width: 749px)">
            <Recommendation 
              controller={controller}
              pagination={true}
              prevButton={<ArrowLeft/>}
              nextButton={<ArrowRight/>}
              breakpoints={breakpointsMobile}
              allowTouchMove={true}
            >
              {store.results.map((result) => (
                <Result result={result}></Result>
              ))}
            </Recommendation>
          </MediaQuery>
        </div>
      </ControllerProvider>
    );
  }
}
